'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { NavigationCard } from './navigation-card';
import { useCardsNavigationSwiper } from './use-cards-navigation-swiper';
import type { FiancesNavigationCard } from '../../types';
import type { Route } from 'next';
import type { SwiperOptions } from 'swiper/types';
interface CardsNavigationSwipperProps {
  cardsNavigationInformation: FiancesNavigationCard[];
}
function CardsNavigationSwipper(t0) {
  const $ = _c(36);
  const {
    cardsNavigationInformation
  } = t0;
  let t1;
  if ($[0] !== cardsNavigationInformation.length) {
    t1 = {
      cardsCount: cardsNavigationInformation.length
    };
    $[0] = cardsNavigationInformation.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    handleAfterInit,
    adjustCardHeights,
    swiperRef,
    isSwiperReady,
    showSwiper,
    isDeepLevel,
    itemsCount
  } = useCardsNavigationSwiper(t1);
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: "bullets",
      enabled: true,
      clickable: true
    };
    t3 = {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 8
    };
    t4 = {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 8
    };
    t5 = {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 16
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = isDeepLevel ? 4 : 3;
  const t7 = isDeepLevel ? 4 : 3;
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = {
      slidesPerView: t6,
      slidesPerGroup: t7,
      spaceBetween: 8
    };
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = isDeepLevel ? 6 : 5;
  const t10 = isDeepLevel ? 6 : 5;
  let t11;
  if ($[9] !== t10 || $[10] !== t9) {
    t11 = {
      slidesPerView: t9,
      slidesPerGroup: t10,
      spaceBetween: 8
    };
    $[9] = t10;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = isDeepLevel ? 6 : 5;
  const t13 = isDeepLevel ? 6 : 5;
  const t14 = isDeepLevel ? 32 : 8;
  let t15;
  if ($[12] !== t12 || $[13] !== t13 || $[14] !== t14) {
    t15 = {
      slidesPerView: t12,
      slidesPerGroup: t13,
      spaceBetween: t14
    };
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t11 || $[17] !== t15 || $[18] !== t8) {
    t16 = {
      pagination: t2,
      breakpoints: {
        0: t3,
        640: t4,
        768: t5,
        1024: t8,
        1280: t11,
        1440: t15
      }
    };
    $[16] = t11;
    $[17] = t15;
    $[18] = t8;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const swiperOptions = t16;
  const t17 = !showSwiper && "gap-4 md:gap-6 xl:gap-8";
  const t18 = itemsCount === 1 && !showSwiper && "lg:[&>div:nth-of-type(1)]:max-w-[calc(100%/3-24px)]";
  const t19 = itemsCount === 1 && !showSwiper && "xl:[&>div:nth-of-type(1)]:max-w-[calc(100%/3-32px)] xl:[&>div:nth-of-type(1)]:min-w-[calc(100%/3-32px)]";
  let t20;
  if ($[20] !== t17 || $[21] !== t18 || $[22] !== t19) {
    t20 = cn("flex w-full flex-row flex-nowrap", t17, t18, t19);
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== adjustCardHeights || $[25] !== cardsNavigationInformation || $[26] !== handleAfterInit || $[27] !== isDeepLevel || $[28] !== isSwiperReady || $[29] !== showSwiper || $[30] !== swiperOptions || $[31] !== swiperRef) {
    t21 = showSwiper ? <div data-slot="swiper-wrapper" className={cn("relative w-full min-w-0 flex-1", "-my-2 py-2")}><Swiper direction="horizontal" modules={[Pagination, Navigation]} pagination={true} onAfterInit={handleAfterInit} onResize={adjustCardHeights} onBreakpoint={adjustCardHeights} ref={swiperRef} className={cn("pb-10!", "[&_.swiper-slide]:box-border [&_.swiper-slide]:flex [&_.swiper-slide]:h-auto", "[&_.swiper-pagination-horizontal]:relative [&_.swiper-pagination-horizontal]:mt-6", "[&_.swiper-pagination-bullet]:h-3 [&_.swiper-pagination-bullet]:w-3", "[&_.swiper-pagination-bullet]:md:h-4 [&_.swiper-pagination-bullet]:md:w-4", !isSwiperReady && "hidden!")} {...swiperOptions}>{cardsNavigationInformation.map(card => <SwiperSlide key={card.code}><div data-slot="card-wrapper" className={cn("box-border flex h-full w-full", "p-1")}><NavigationCard href={card.href as Route} image={card.image} title={card.title} description={card.description} code={card.code} isCompact={isDeepLevel} className="swiper-milestone-card h-full" /></div></SwiperSlide>)}</Swiper></div> : <div className="flex flex-1 gap-6 xl:gap-8">{cardsNavigationInformation.map(card_0 => <NavigationCard key={card_0.code} href={card_0.href as Route} image={card_0.image} title={card_0.title} description={card_0.description} code={card_0.code} isCompact={isDeepLevel} className="navigation-card-height" />)}</div>;
    $[24] = adjustCardHeights;
    $[25] = cardsNavigationInformation;
    $[26] = handleAfterInit;
    $[27] = isDeepLevel;
    $[28] = isSwiperReady;
    $[29] = showSwiper;
    $[30] = swiperOptions;
    $[31] = swiperRef;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t20 || $[34] !== t21) {
    t22 = <div data-slot="container-cards-navigation" className={t20}>{t21}</div>;
    $[33] = t20;
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  return t22;
}
export { CardsNavigationSwipper };